import { createJSONStorage, sessionStorageSource } from "@/storage/browser"
import { readUserSessionToken } from "@/storage/user-session"
import type { SmallModelRoute } from "@/utils/small-model-routes"

const storage = createJSONStorage<{ scope: string; routes: SmallModelRoute[] } | undefined>(
  "mux.small-model-routes.snapshot.v1",
  {
    decode(value) {
      if (!value || typeof value !== "object") return undefined
      const candidate = value as { scope?: unknown; routes?: unknown }
      if (typeof candidate.scope !== "string" || !Array.isArray(candidate.routes)) return undefined
      const routes = candidate.routes.filter((route): route is SmallModelRoute => {
        if (!route || typeof route !== "object") return false
        const item = route as Partial<SmallModelRoute>
        return typeof item.providerID === "string" && typeof item.modelID === "string" &&
          (item.variant === undefined || typeof item.variant === "string")
      })
      return { scope: candidate.scope, routes }
    },
  },
  sessionStorageSource,
)

export function readSmallModelRoutesSnapshot() {
  const value = storage.read(undefined)
  if (!value || value.scope !== readUserSessionToken()) return undefined
  return value.routes.map((route) => ({ ...route }))
}

export function seedSmallModelRoutesSnapshot(routes: SmallModelRoute[]) {
  storage.write({
    scope: readUserSessionToken(),
    routes: routes.map((route) => ({ ...route })),
  })
}
